module.exports = "import React from 'react';\nimport Checkbox from 'material-ui/Checkbox';\n\nconst StylesOverridingInlineExample = () => (\n  <Checkbox\n    name=\"StylesOverridingInlineExample\"\n    label=\"Checked the mail\"\n    style={{\n      width: '50%',\n      margin: '0 auto',\n      border: '2px solid #FF9800',\n      backgroundColor: '#ffd699',\n    }}\n  />\n);\n\nexport default StylesOverridingInlineExample;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/customization/StylesOverridingInlineExample.js
 ** module id = 1097
 ** module chunks = 0
 **/